<template>
<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24" v-if="user">
		<h4>{{user.name}}</h4>
		<div class="fs-small color-gray-500 margin-b-16"></div>

		<c-splitbutton class="margin-b-24" :buttons="buttons"></c-splitbutton>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Emailadres</span>
			</div>
			<div class="columns small-12 medium-8">
				{{user.contact ? user.contact.email : user.email}}
			</div>
		</div>

		<div class="row margin-b-16 fs-xsmall" v-for="role in user.roles" :key="role.id">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Rol</span>
			</div>
			<div class="columns small-12 medium-8">
                {{role.name}}
			</div>
		</div>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Twee Factor Authenticatie</span>
			</div>
			<div class="columns small-12 medium-8">
                {{user.otp_enabled ? 'Actief' : 'Inactief'}}
			</div>
		</div>
    </div>

    <c-remove
        v-show="removeUserModal"
        :size="'medium'"
        :text="'gebruiker'"
        @close="removeUserModal=false"
        @remove="removeUser()">
    </c-remove>

</template>

<script>
import CSplitbutton from '@components/Splitbutton';
import CRemove from '@app/modals/Remove';
import { mapGetters } from 'vuex';

export default {
	components: { CSplitbutton, CRemove },
	props: {
		user: {
			type: Object,
			required: true
		}
	},
	data() {
			return {
                removeUserModal: false,
		}
	},
	methods : {
		trigger(event) {
           this.$store.dispatch('listener/emit', event);
		},
        openModalRemoveUser() {
            this.removeUserModal = true;
        },
        removeUser(){
            this.$xhr.delete('/api/users/' + this.user.id).then( ( {result}) => {
                this.$store.dispatch('toast/success', {title: 'Gebruiker verwijderen', text: 'Gebruiker is verwijderd'});
                close();
                window.location.replace("/");
            }).catch( (e) => {
                this.$store.dispatch('toast/alert', {title: 'Gebruiker verwijderen', text: 'Er is helaas iets fout gegaan bij het verwijderen'});
            });
        }
	},

	computed: {
		...mapGetters({
			can: 'user/can',
		}),
		buttons() {

			const buttons = [];
			this.can('Gebruiker wijzigen') && buttons.push({
				label: 'Bewerken',
				action: () => {
                    this.$store.dispatch('listener/emit', 'change-user');
                },
			});

			this.can('Gebruiker verwijderen') && buttons.push({
				label: 'Verwijderen',
                action: () => {
                    this.openModalRemoveUser();
                },
			});

			this.can('2FA uitschakelen') && this.user.otp_enabled && buttons.push({
				label: '2FA resetten',
                action: () => {
					this.$store.dispatch('listener/emit', 'remove-2fa');
                },
			});


			return buttons;
		},
	}
}
</script>
